import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { PageHeader, PageShell } from '@/components/portal/page-header'
import { PlotDetailsReadonly, plotLocationLine } from '@/components/plots/plot-details-readonly'
import { DocumentRequestCard } from '@/components/document-requests/document-request-card'
import { useMyPlot } from '@/hooks/use-plots'
import { useDocumentRequests } from '@/hooks/use-document-requests'

export function MemberPlotDetail() {
  const { plotId } = useParams<{ plotId: string }>()
  const { data, isLoading, error } = useMyPlot(plotId)
  const { data: requestsData } = useDocumentRequests({ plotId })
  const plot = data?.data
  const requests = requestsData?.data ?? []

  if (isLoading) {
    return (
      <PageShell>
        <p className="font-sans text-sm text-muted-foreground">Loading plot…</p>
      </PageShell>
    )
  }

  if (error || !plot) {
    return (
      <PageShell>
        <p className="font-sans text-sm text-destructive">Plot not found.</p>
        <Link to="/profile?tab=plots" className="mt-4 inline-block text-sm text-primary">
          Back to profile
        </Link>
      </PageShell>
    )
  }

  return (
    <PageShell>
      <PageHeader
        label="My plot"
        title={`Plot ${plot.newNumber}`}
        description={plotLocationLine(plot)}
        action={
          <Link
            to="/profile?tab=plots"
            className="inline-flex items-center gap-2 font-sans text-sm text-primary hover:text-green-lt"
          >
            <ArrowLeft className="size-4" aria-hidden />
            Back to profile
          </Link>
        }
      />

      <div className="max-w-xl">
        <PlotDetailsReadonly plot={plot} />
      </div>

      {requests.length > 0 && (
        <div className="mt-6 space-y-4">
          <h2 className="font-serif text-lg text-ink">Requested documents</h2>
          {requests.map((request) => (
            <DocumentRequestCard key={request.id} request={request} />
          ))}
        </div>
      )}
    </PageShell>
  )
}
